import {
  SERVICE_GET_LIST,
  SERVICE_GET_LIST_SUCCESS,
  SERVICE_GET_LIST_ERROR,
  SERVICE_GET_LIST_WITH_FILTER,
  SERVICE_GET_LIST_WITH_ORDER
} from "../actions";

import { arrayToObject } from "../../helpers/Utils";

const INIT_STATE = {
  allServiceItems: {},
  serviceItems: [],
  error: "",
  showToast: false,
  filter: null,
  searchKeyword: "",
  orderColumn: { column: "created_at", label: "Creation Date", direction: "desc" },
  loading: false,
  orderColumns: [
    { column: "created_at", label: "Creation Date", direction: "desc" },
    { column: "updated_at", label: "Last Update", direction: "desc" }
  ],
  categories: [],
  selectedItems: []
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SERVICE_GET_LIST:
      return { ...state, loading: false };

    case SERVICE_GET_LIST_SUCCESS: {
      if (action.payload.length > 0) {
        let allServiceItemsObj = {};
        allServiceItemsObj = arrayToObject(action.payload, "id");
        allServiceItemsObj = { ...allServiceItemsObj };

        return {
          ...state,
          loading: true,
          allServiceItems: { ...allServiceItemsObj },
          serviceItems: [...Object.values(allServiceItemsObj)]
        };
      }
      return {
        ...state,
        loading: true
      };
    }

    case SERVICE_GET_LIST_ERROR:
      return { ...state, loading: true, error: action.payload };

    case SERVICE_GET_LIST_WITH_FILTER: {
      if (action.payload.column === "" || action.payload.value === "") {
        return {
          ...state,
          // loading: true,
          serviceItems: [...Object.values(state.allServiceItems)],
          filter: null,
          searchKeyword: ""
        };
      }

      const filteredItems = Object.keys(state.allserviceItems).reduce((r, e) => {
        const toReturn = r;
        if (state.allServiceItems[e][action.payload.column] === action.payload.value) toReturn[e] = state.allServiceItems[e];
        return toReturn;
      }, {});

      return {
        ...state,
        // loading: true,
        serviceItems: [...Object.values(filteredItems)],
        filter: {
          column: action.payload.column,
          value: action.payload.value
        },
        searchKeyword: ""
      };
    }

    case SERVICE_GET_LIST_WITH_ORDER: {
      if (action.payload === "" || action.payload.column === "") {
        return {
          ...state,
          // loading: true,
          serviceItems: state.serviceItems,
          orderColumn: { column: "created_at", label: "Creation Date", direction: "desc" }
        };
      }
      const sortedItems =
        action.payload.direction === "asc"
          ? state.serviceItems.sort((a, b) => {
              if (a[action.payload.column] < b[action.payload.column]) return -1;
              if (a[action.payload.column] > b[action.payload.column]) return 1;

              return 0;
            })
          : state.serviceItems.sort((a, b) => {
              if (a[action.payload.column] > b[action.payload.column]) return -1;
              if (a[action.payload.column] < b[action.payload.column]) return 1;

              return 0;
            });
      return {
        ...state,
        // loading: true,
        serviceItems: sortedItems,
        orderColumn: state.orderColumns.find(x => x.column === action.payload.column)
      };
    }

    default:
      return state;
  }
};
